import { Component, OnInit } from '@angular/core';
import { GetSetOperations } from 'app/shared/common/helper/profile';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  screenShots: Boolean;
  profileId = '';
  settingsForm: FormGroup;
  objectId = '';
  screenshotTimingList = [];
  roleList = [];
  customRoles = [];
  employeesList: string;
  projectsList: string;
  roleName: any;
  currentUser = this.parseService.instance.User.current();
  oldvalue: any;
  notificationSettingsForm: FormGroup;
  notificationSettingsOldValues: any;
  constructor(
    private profileInterface: GetSetOperations,
    private route: ActivatedRoute,
    private queryInterface: QueryInterface,
    private parseService: ParseService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private hardCodedValues: HardCodedValues,
    private activityCenterService: ActivityCenterService
  ) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.objectId = params['id'];
      this.profileId = this.objectId;
    });

    this.getSettings();
    this.getLabels();
    this.getRoles();

    this.settingsForm = this.formBuilder.group({
      screenshot: [''],
      isMeeting: [''],
      screenShotSyncTime: ['', Validators.required],
      isWebDesktop: [false],
      notification: ['']
      // meetingMode: ['', Validators.required],
      // idleTime: ['', Validators.required],
      // autoThreshold: ['', Validators.required],
      // workHours: ['', Validators.required],
      // breakHours: ['', Validators.required],
      // inTimeGrace: ['', Validators.required],
    });

    this.notificationSettingsForm = this.formBuilder.group({
      login: [''],
      logout: [''],
      projectSwitched: [''],
    });
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  async screenShot(event) {
    let values = this.settingsForm.value;
    let activities = await this.activityCenterService.getActivity(this.oldvalue, values, 'Screenshot');
    this.activityCenterService.createActivity(activities, this.hardCodedValues.profileView, this.objectId);

    this.profileInterface.setScreenShot(this.objectId, event.checked).then(res => {
      this.getSettings();
    });
  }

  async meeting(event) {
    let values = this.settingsForm.value;
    let activities = await this.activityCenterService.getActivity(this.oldvalue, values, 'Meeting');
    this.activityCenterService.createActivity(activities, this.hardCodedValues.profileView, this.objectId);

    this.profileInterface.meetingSave(this.objectId, event.checked).then(res => {
      this.getSettings();
    });
  }

  async updateSettings() {
    if (this.settingsForm.valid) {
      let values = this.settingsForm.value;
      let activities = await this.activityCenterService.getActivity(this.oldvalue, values, this.hardCodedValues.profileView);
      this.activityCenterService.createActivity(activities, this.hardCodedValues.profileView, this.profileId);

      let queryInstance = this.parseService.instance.Object.extend('Profile');
      let query = new this.parseService.instance.Query(queryInstance);
      query.equalTo('objectId', this.profileId);
      let result = await query.find();
      let settingsDetail = result[0];
      settingsDetail.set('screenshot', values.screenshot);
      settingsDetail.set('isMeeting', values.isMeeting);
      settingsDetail.set('screenShotSyncTime', this.convertHourMinutesToSeconds(values.screenShotSyncTime));
      settingsDetail.set('isWebDesktop', values.isWebDesktop);
      settingsDetail.set('isNotificationShow', values.notification);

      // settingsDetail.set('idleTime', this.convertHourMinutesToSeconds(values.idleTime));
      // settingsDetail.set('inTimeGrace', this.convertHourMinutesToSeconds(values.inTimeGrace));
      // settingsDetail.set('meetingMode', this.convertHourMinutesToSeconds(values.meetingMode));
      // settingsDetail.set('autoThreshold', this.convertHourMinutesToSeconds(values.autoThreshold));
      // settingsDetail.set('workHours', this.convertHourMinutesToSeconds(values.workHours));
      // settingsDetail.set('breakHours', this.convertHourMinutesToSeconds(values.breakHours));
      let data = await settingsDetail.save();
      this.toastr.success('Saved Successfully');
      this.getSettings();
    }
  }

  convertHourMinutesToSeconds(value) {
    var hms = value;   // your input string
    var a = hms.split(':'); // split it at the colons

    // minutes are worth 60 seconds. Hours are worth 60 minutes.
    var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60;
    return seconds;
  }

  keylogger(event) {
    let values = this.settingsForm.value;
    this.profileInterface.keyloggerSave(this.objectId, event.checked);
    this.getSettings();
  }

  async login(event) {
    let values = this.notificationSettingsForm.value;
    let activities = await this.activityCenterService.getActivity(this.notificationSettingsOldValues, values, 'isLogin');
    this.activityCenterService.createActivity(activities, this.hardCodedValues.profileView, this.objectId);

    this.profileInterface.saveNotificationDetails(this.objectId, event.checked, 'isLogin').then(res => {
      this.getSettings();
    });
  }


  async logout(event) {
    let values = this.notificationSettingsForm.value;
    let activities = await this.activityCenterService.getActivity(this.notificationSettingsOldValues, values, 'isLogout');
    this.activityCenterService.createActivity(activities, this.hardCodedValues.profileView, this.objectId);

    this.profileInterface.saveNotificationDetails(this.objectId, event.checked, 'isLogout').then(res => {
      this.getSettings();
    });
  }

  async projectSwitched(event) {
    let values = this.notificationSettingsForm.value;
    let activities = await this.activityCenterService.getActivity(this.notificationSettingsOldValues, values, 'isProjectSwitched');
    this.activityCenterService.createActivity(activities, this.hardCodedValues.profileView, this.objectId);

    this.profileInterface.saveNotificationDetails(this.objectId, event.checked, 'isProjectSwitched').then(res => {
      this.getSettings();
    });
  }

  async getSettings() {
    let condition = [
      { condition: 'equalTo', field: 'objectId', value: this.objectId },
      { condition: 'include', field: 'role' }
    ];
    await this.queryInterface.executeQuery(this.parseService, 'Profile', condition).then(results => {
      let result = results[0];
      this.roleName = result.get('role').get('name');
      let screenshots = result.get('screenShot');
      let isMeeting = result.get('isMeeting');
      let notification = result.get('isNotificationShow') ? result.get('isNotificationShow') : false;
      let isWebDesktop = result.get('isWebDesktop') ? result.get('isWebDesktop') : false;
      this.settingsForm.patchValue({
        isMeeting: isMeeting,
        screenshot: screenshots,
        screenShotSyncTime: this.secondsToHms(result.get('screenShotSyncTime')),
        isWebDesktop: isWebDesktop,
        notification: notification
        // meetingMode: this.secondsToHms(result.get('meetingMode')),
        // autoThreshold: this.secondsToHms(result.get('autoThreshold')),
        // workHours: this.secondsToHms(result.get('workHours')),
        // breakHours: this.secondsToHms(result.get('breakHours')),
        // idleTime: this.secondsToHms(result.get('idleTime')),
        // inTimeGrace: this.secondsToHms(result.get('inTimeGrace')),
      });
      this.oldvalue = JSON.parse(JSON.stringify(this.settingsForm.value));
    });
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay + ':' + sDisplay;
  }

  async getLabels() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    await query.find().then(results => {
      let result = results[0];
      this.roleList = result.get('roleList');
    });
  }

  dateEstimate(event) {

  }

  getRoles() {
    let condition = [
      { condition: 'equalTo', field: 'profile', value: { __type: 'Pointer', className: 'Profile', objectId: this.objectId } },
    ];
    this.queryInterface.executeQuery(this.parseService, 'CustomRoleSettings', condition).then(results => {
      let result = results[0];
      this.customRoles = result.get('customRoles');

      let employeesdata = this.customRoles[0];
      var keys = Object.keys(employeesdata);
      var filtered = keys.filter(function (key) {
        if (typeof employeesdata[key] != 'string') {
          return employeesdata[key]
        }
      });

      let projectsdata = this.customRoles[1];
      var keys = Object.keys(projectsdata);
      var filtered1 = keys.filter(function (key) {
        if (typeof projectsdata[key] != 'string') {
          return projectsdata[key]
        }
      });

      this.employeesList = filtered[0];
      this.projectsList = filtered1[0];
    });
  }

  employeesSettings(event, roleList) {
    let type = JSON.parse(JSON.stringify(event));
    let role;
    role = this.setEmployeesModel(event, roleList);
    let roleSettings = this.customRoles.findIndex(x => x.moduleName == role.moduleName);
    this.customRoles[roleSettings] = role;

    const queryInstance = this.parseService.instance.Object.extend('CustomRoleSettings');
    const query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.objectId });
    query.find().then(res => {
      let roleDetail = res[0];
      roleDetail.set('customRoles', this.customRoles);
      roleDetail.save().then(async (result) => {
        let customRoles = result.get('customRoles');

        let employees = customRoles.filter(x => x.moduleName == 'Employees');
        let projects = customRoles.filter(x => x.moduleName == 'Projects');

        function getKeyByValueEmployee(object, value) {
          return Object.keys(object).find(key =>
            object[key] === value);
        }

        function getKeyByValueProject(object, value) {
          return Object.keys(object).find(key =>
            object[key] === value);
        }

        employees.forEach(res => {
          let ans = getKeyByValueEmployee(res, true);
          if (type == 'Employees') {
            this.activityCreation(type, ans);
          }
        })

        projects.forEach(res => {
          let ans = getKeyByValueProject(res, true);
          if (type == 'Projects') {
            this.activityCreation(type, ans);
          }
        })

        this.toastr.success('Saved Successfully !', '', {
          timeOut: 1000
        });
      }, (error) => {
      });
    });
  }

  setEmployeesModel(event, roleList): any {
    if (roleList.role == 'All') {
      const employees = {
        moduleName: event,
        All: true,
        Assigned: false,
        None: false,
      };
      return employees;
    }
    else if (roleList.role == 'Assigned') {
      const employees = {
        moduleName: event,
        All: false,
        Assigned: true,
        None: false,
      };
      return employees;
    }
    else if (roleList.role == 'None') {
      const employees = {
        moduleName: event,
        All: false,
        Assigned: false,
        None: true,
      };
      return employees;
    }
  }

  activityCreation(type, fieldName) {
    let activityClass = this.parseService.instance.Object.extend("ActivityCenter");
    var activityDetails = new activityClass();
    activityDetails.set("moduleType", 'Profile-View');
    activityDetails.set("updatedBy", { __type: 'Pointer', className: 'Profile', objectId: this.currentUser.get('profile').id });
    if (type == 'Employees') {
      activityDetails.set("message", fieldName + ' employees enabled');
    }
    else if (type == 'Projects') {
      activityDetails.set("message", fieldName + ' projects enabled');
    }
    activityDetails.set('updatedId', this.objectId);
    activityDetails.save();
  }


}
